import React from 'react';
import {withRouter} from 'react-router-dom'
import { Upload, message } from 'antd';
import { InboxOutlined, SearchOutlined } from '@ant-design/icons';
import { Radio, Table, Button, Alert, Typograph, Input } from 'antd';
import Icon from '@ant-design/icons';
import {getApiUrl, moneyFormat} from '../../utils.js'
import { connect } from "react-redux";
import {Divider, Tag } from 'antd';
import Highlighter from 'react-highlight-words';
import get from "lodash.get";
//import './obsolete.css';



class VisualizzaSconti extends React.Component {

    constructor(props) {
        super(props)
        
        this.state = {
            listaScontiObsoleti: [],
           
        }

        this.setResults = this.setResults.bind(this)

    }

    setResults(data){
        this.setState({
            ...this.state,
            listaScontiObsoleti: data
            
        });
        
        console.log(this.state.listaObsoleti)
       
    }
    //ORDINAMENTO COLONNA CODICE
    


     


   //FILTRO DI RICERCA

   handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };


  handleSearch(selectedKeys, confirm, dataIndex){
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  }


   getColumnSearchProps = (dataIndex, exact, dataIndex2, replaceDotWithComma) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Filtra
          </Button>
          <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Elimina i filtri
          </Button>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#ff471a' : undefined }} />,
    onFilter: function(value, record) {
  
        console.log("On filter called with value: " + value + " and record")
        console.log(record)
        
        if(replaceDotWithComma){
          value = value.replaceAll(',','.')
        }
  
  
        //Search on field1 + field2  
        if(dataIndex2!==null && dataIndex2!==undefined){
          if(exact==null || exact===undefined || exact===false ){
            return ( (get(record, dataIndex) || "")  + "-" + (get(record, dataIndex2) || "") ).toString().toLowerCase().includes(value.toString().toLowerCase())
          }else{
            //exact
            return ( (get(record, dataIndex) || "")  + "-" + (get(record, dataIndex2) || "") ).toString().toLowerCase() === (value.toString().toLowerCase())
          }
          
        }
        else if(exact===null || exact===undefined || exact===false){
          console.log("Search exact false " )
          console.log( ("Record:" + get(record, dataIndex)  || "").toString().toLowerCase() )
          console.log("Value:"  + value.toString().toLowerCase())
          return (get(record, dataIndex)  || "").toString().toLowerCase().includes(value.toString().toLowerCase())
        }
        else{
          return (get(record, dataIndex) || "").toString().toLowerCase() === value.toString().toLowerCase()
        }
    }
      ,
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
  });

   
    

    render() {

        function onChange(pagination, filters, sorter, extra) {
            console.log('params', pagination, filters, sorter, extra);
            console.log(extra)
          }
        
        let setResults = this.setResults;
       // let initLoad = this.initLoad;
       
        fetch(getApiUrl() + "/obsolete/getObsoleteDiscounts",
        {
            method: 'GET', 
            credentials: 'include',
            headers: new Headers({
                "Accept" : 'application/json',
                
            }),}).then(res => res.json()).then(res => {
             
                
                if(!res.error && (!this.state.listaScontiObsoleti.length) && (res.data.length != 0)){
                    setResults(res.data);
                    
                } 
                //let dati = res.data;
               
                }).catch(err => {
                  message.error("Non è stato possibile recuperare la lista di sconti obsoleti o nessuno sconto caricato")
                })
        
              
       


        const columns = [
            {
                title: 'Id Cliente', width: "16%", key: 'uIdCliente', index: 'uIdCliente',
                render: function (text, record, index) {
                    return (<span>{record.uIdCliente}</span>);
                },
                ...this.getColumnSearchProps(["uIdCliente"])
              },
              {
                title: 'Dal', width: "16%", key: 'odStartTime', index: 'odStartTime',
                render: function (text, record, index) {
                    return (<span>{record.odStartTime}</span>);
                },
                dataIndex: 'odStartTime',
               sorter: (a, b) => a.odStartTime.localeCompare(b.odStartTime),
               sortDirections: ['descend', 'ascend'],
                ...this.getColumnSearchProps(["odStartTime"])
              },
              {
                title: 'Al', width: "16%", key: 'odEndTime', index: 'odEndTime',
                render: function (text, record, index) {
                    return (<span>{record.odEndTime}</span>);
                },
                dataIndex: 'odEndTime',
                sorter: (a, b) => a.odEndTime.localeCompare(b.odEndTime),
                sortDirections: ['descend', 'ascend'],
                
                ...this.getColumnSearchProps(["odEndTime"])
              }, 
              {
                title: 'Sconto Acquisto', width: "16%", key: 'odScontoAcq', index: 'odScontoAcq',
                render: function (text, record, index) {
                    return (<span>{record.odScontoAcq}</span>);
                },
                dataIndex: 'odScontoAcq',
                sorter: (a, b) => a.odScontoAcq - b.odScontoAcq,
                sortDirections: ['descend', 'ascend'],
                ...this.getColumnSearchProps(["odScontoAcq"])
              },
              {
                title: 'Sconto Vendita', width: "16%", key: 'odScontoVend', index: 'odScontoVend',
                render: function (text, record, index) {
                    return (<span>{record.odScontoVend}</span>);
                },
                dataIndex: 'odScontoVend',
                sorter: (a, b) => a.odScontoVend - b.odScontoVend,
                sortDirections: ['descend', 'ascend'],
                ...this.getColumnSearchProps(["odScontoVend"])
              }, 
              {
                title: 'Lettera Sconto', width: "16%",   key: 'odCatSc', index: 'odCatSc',
                render: function (text, record, index) {
                    return (<span>{record.odCatSc}</span>);
                },
                ...this.getColumnSearchProps(["odCatSc"])
              }, 
             
              
             

        ]
        
        return(  
            <div> 
                <Table key={this.state.listaScontiObsoleti.key} columns={columns} dataSource={this.state.listaScontiObsoleti} onChange={onChange}></Table>      
            </div>
            )
                         


    
            
                    

    }




}
export default withRouter(VisualizzaSconti)